export type UrlPathObject = Record<string, string | undefined>;

export interface UrlPath {
    languages: string[];
    path: string;
}

export function generateAllPaths(urlPath: UrlPathObject): UrlPath[] {
    const urlPaths: UrlPath[] = Object.entries(urlPath).reduce((acc: UrlPath[], [lang, path]) => {
        const existingPath = acc.find((item) => item.path === path);
        if (existingPath) {
            existingPath.languages.push(lang);
        } else {
            acc.push({ languages: [lang], path: path || '' });
        }
        return acc;
    }, []) as UrlPath[];

    return urlPaths;
}
